// FIXME(EUD-705): coercing to numbers shouldn't be the way we do this
// we should use the enum members directly, but it requires a bigger refactor

/** Coerce a numeric enum member to plain `number` (for API id comparisons). */
function enumToNumber(member: number): number {
  return member;
}

export enum ClassificationIds {
  ASSET = 2,
  LIABILITY = 3,
  PERSONAL_PROPERTY = 10,
  PRIVATE_INVESTMENT = 6,
  REAL_ESTATE = 8,
  BANKING = 4,
}

/** Numeric {@link ClassificationIds} values for comparing API `number` fields. */
export const ClassificationIdNumber = {
  ASSET: enumToNumber(ClassificationIds.ASSET),
  LIABILITY: enumToNumber(ClassificationIds.LIABILITY),
  PERSONAL_PROPERTY: enumToNumber(ClassificationIds.PERSONAL_PROPERTY),
  PRIVATE_INVESTMENT: enumToNumber(ClassificationIds.PRIVATE_INVESTMENT),
  REAL_ESTATE: enumToNumber(ClassificationIds.REAL_ESTATE),
  BANKING: enumToNumber(ClassificationIds.BANKING),
} as const;

/**
 * `AdvisorInvestor.OnboardingStep` values (client registration progress).
 * Drives bulk-action eligibility on the Clients page.
 */
export enum OnboardingStep {
  NOT_INVITED = 1,
  INVITED = 2,
  ACTIVE = 3,
}

/** Numeric {@link OnboardingStep} values for comparing API `number` fields. */
export const OnboardingStepNumber = {
  NOT_INVITED: enumToNumber(OnboardingStep.NOT_INVITED),
  INVITED: enumToNumber(OnboardingStep.INVITED),
  ACTIVE: enumToNumber(OnboardingStep.ACTIVE),
} as const;

/**
 * `AccountBase.AccountType` values (backend `WealthType`). Drives the grid's
 * Data Source / institution derivation.
 */
export enum AccountType {
  LINKED = 1,
  MANUALLY_ENTERED = 2,
  ESTATE = 3,
  ENTITY = 4,
  ADVISOR_MANAGED = 8,
}

/** Numeric {@link AccountType} values for comparing API `number` fields. */
export const AccountTypeNumber = {
  LINKED: enumToNumber(AccountType.LINKED),
  MANUALLY_ENTERED: enumToNumber(AccountType.MANUALLY_ENTERED),
  ESTATE: enumToNumber(AccountType.ESTATE),
  ENTITY: enumToNumber(AccountType.ENTITY),
  ADVISOR_MANAGED: enumToNumber(AccountType.ADVISOR_MANAGED),
} as const;

/**
 * Values for `AccountBase.TransactionTypeId` / offline account transaction type.
 */
export enum WealthAccountTransactionTypeIds {
  CASH_FLOW = 1,
  INVESTMENT_ACTIVITY = 2,
}

/** Numeric {@link WealthAccountTransactionTypeIds} values for comparing API `number` fields. */
export const WealthAccountTransactionTypeIdNumber = {
  CASH_FLOW: enumToNumber(WealthAccountTransactionTypeIds.CASH_FLOW),
  INVESTMENT_ACTIVITY: enumToNumber(
    WealthAccountTransactionTypeIds.INVESTMENT_ACTIVITY,
  ),
} as const;

/**
 * Sentinels when primary/sub classification is missing on the account row (null in DB).
 */
export const OFFLINE_ACCOUNT_UNSET_CLASSIFICATION_IDS = {
  primary: 0,
  sub: 0,
} as const;

/**
 * Level-2 (and deeper) classification ids used as sub-classifications under a level-1 `ClassificationId`.
 */
export enum SubClassificationIds {
  MORTGAGE = 12,
  VEHICLE = 55,
  INVESTMENT_OWNED = 64,
  INVESTMENT_PARTIALLY_OWNED = 65,
}

/** Numeric {@link SubClassificationIds} values for comparing API `number` fields. */
export const SubClassificationIdNumber = {
  MORTGAGE: enumToNumber(SubClassificationIds.MORTGAGE),
  VEHICLE: enumToNumber(SubClassificationIds.VEHICLE),
  INVESTMENT_OWNED: enumToNumber(SubClassificationIds.INVESTMENT_OWNED),
  INVESTMENT_PARTIALLY_OWNED: enumToNumber(
    SubClassificationIds.INVESTMENT_PARTIALLY_OWNED,
  ),
} as const;

export enum DiversificationIds {
  ALTERNATIVES = 5,
  PRIVATE_EQUITY = 45,
  REAL_ASSETS = 43,
  CASH = 4,
  BANK = 40,
  OTHER = 6,
  FUNDS = 65,
  INVESTMENT_REAL_ESTATE = 51,
  RESIDENTIAL_REAL_ESTATE = 52,
}

/** Numeric {@link DiversificationIds} values for comparing API `number` fields. */
export const DiversificationIdNumber = {
  ALTERNATIVES: enumToNumber(DiversificationIds.ALTERNATIVES),
  PRIVATE_EQUITY: enumToNumber(DiversificationIds.PRIVATE_EQUITY),
  REAL_ASSETS: enumToNumber(DiversificationIds.REAL_ASSETS),
  CASH: enumToNumber(DiversificationIds.CASH),
  BANK: enumToNumber(DiversificationIds.BANK),
  OTHER: enumToNumber(DiversificationIds.OTHER),
  FUNDS: enumToNumber(DiversificationIds.FUNDS),
  INVESTMENT_REAL_ESTATE: enumToNumber(
    DiversificationIds.INVESTMENT_REAL_ESTATE,
  ),
  RESIDENTIAL_REAL_ESTATE: enumToNumber(
    DiversificationIds.RESIDENTIAL_REAL_ESTATE,
  ),
} as const;

/**
 * Root diversification scheme node for portfolio-level asset allocation queries.
 */
export enum PortfolioDiversificationIds {
  ROOT = 1,
}

/** Numeric {@link PortfolioDiversificationIds} values for comparing API `number` fields. */
export const PortfolioDiversificationIdNumber = {
  ROOT: enumToNumber(PortfolioDiversificationIds.ROOT),
} as const;

/**
 * `DiversificationCategoryId` values on diversification scheme categories.
 */
export enum DiversificationCategoryIds {
  CLASSIFICATION = 6,
}

/** Numeric {@link DiversificationCategoryIds} values for comparing API `number` fields. */
export const DiversificationCategoryIdNumber = {
  CLASSIFICATION: enumToNumber(DiversificationCategoryIds.CLASSIFICATION),
} as const;

/** Sentinel when diversification `categoryId` is omitted (not a valid positive id). */
export const UNSET_DIVERSIFICATION_CATEGORY_ID = 0 as const;

export enum ThemeTab {
  LightMode = 'light-mode',
  DarkMode = 'dark-mode',
}
